import {connect} from "react-redux";
import PJPSubmission from "./Create";
import {bindActionCreators} from "redux";
import {getAM, getAMTollByUserId, amMonthlyPlan} from "../../../../service/FasttagToll/action";
const mapStateToProps = (state) => ({
    allAm:state.FasttagToll.allAm,
    amTollDetails:state.FasttagToll.amTollDetails,
    monthlyPlan:state.FasttagToll.monthlyPlan,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getAM,
            getAMTollByUserId,
            amMonthlyPlan
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PJPSubmission);
